import { isMainGameDomain } from '../../../../config/environment/environment';
import { bootPathname, bootSearchParams } from '../../../../config/boot/bootUrl';

export function shouldShowHomeModePicker(): boolean {
  if (typeof window === 'undefined') return false;
  if (bootPathname() !== '/') return false;
  if (isMainGameDomain()) return false;
  const sp = bootSearchParams();
  if (sp.has('class')) return false;
  if (sp.has('map')) return false;
  if (sp.has('preset')) return false;
  return true;
}
